<template>
  <div id="search-box">
    <el-row >
      <el-col :span="3" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('refCode')}}</label>
        <el-input v-model="filter.refCode"
                  :placeholder="$t('code')"
                  size="mini"></el-input>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('hotel')}}</label>
        <el-select v-model="filter.hotelId"
                   :placeholder="$t('all')"
                   size="mini"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(hotel, index) in sortedHotelList"
            :key="index"
            :label="hotel.name"
            :value="hotel.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;" v-if="isShowFromAgent === false">
        <label class="label-form-search">{{$t('agent')}}</label>
        <el-select v-model="filter.agentId"
                   :placeholder="$t('all')"
                   size="mini"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(agent, index) in sortedAgentList"
            :key="index"
            :label="agent.name"
            :value="agent.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" v-if="isShowFromAgent === false">
        <label class="label-form-search">{{$t('market')}}</label>
        <el-select v-model="filter.marketId"
                   :placeholder="$t('all')"
                   size="mini"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(market, index) in sortedMarketList"
            :key="index"
            :label="market.name"
            :value="market.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;" >
        <label class="label-form-search">{{$t('contractValid')}}</label><br>
        <el-date-picker v-model="filter.contractValid" style="width: 100% !important;"
                        type="date"
                        format="d MMM yyyy"
                        value-format="yyyy-MM-dd"
                        :placeholder="$t('selectDate')"
                        size="mini">
        </el-date-picker>
      </el-col>
      <el-col :span="3" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('salePerson')}}</label>
        <el-select v-model="filter.salePersonId"
                   :placeholder="$t('all')"
                   size="mini"
                   filterable>
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            v-for="(salePerson, index) in sortedSalePersonList"
            :key="index"
            :label="`${salePerson.firstName} ${salePerson.lastName}`"
            :value="salePerson.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2" style="padding: 0 5px;">
        <label class="label-form-search">{{$t('status')}}</label>
        <el-select v-model="filter.status"
                   :placeholder="$t('all')"
                   size="mini">
          <el-option :label="$t('all')" value=""></el-option>
          <el-option
            :label="$t('draft')"
            :value="CONTRACT_STATUS.DRAFT">
          </el-option>
          <el-option
            :label="$t('published')"
            :value="CONTRACT_STATUS.PUBLISHED">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="(isShowFromAgent === true)? 10 : 4" style="text-align: right;">
        <br />
        <el-button-group size="mini">
          <el-button type="primary"
                     size="mini"
                     @click="onSearchButtonClick">
            {{ $t('search') }}
          </el-button>
          <el-button type="info"
                     size="mini"
                     @click="onResetButtonClick">
            {{ $t('reset') }}
          </el-button>
        </el-button-group>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CONTRACT_STATUS, VUEX_EVENT } from '@/configs/constant'
import i18nMessages from '@/translations/Contract/List.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import { mapState } from 'vuex'

export default {
  name: 'ContractSearchComponent',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  i18n: { messages: i18nMessages },
  props: {
    hotelList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    },
    salePersonList: {
      type: Array,
      default: () => {
        return []
      }
    },
    isShowFromAgent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      contractSearchCriteria: state => state.contract.contractSearchCriteria
    })
  },
  created: function () {
    this.sortedHotelList = this.hotelList.sort((a, b) => {
      return (a.name > b.name) ? 1 : -1
    })
    this.sortedAgentList = this.agentList.sort((a, b) => {
      return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
    })
    this.sortedSalePersonList = this.salePersonList.sort((a, b) => {
      return (a.firstName.toLowerCase() > b.firstName.toLowerCase()) ? 1 : -1
    })
    this.sortedMarketList = this.marketList.sort((a, b) => {
      return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1
    })
    this.marketListById = this._prepareMarketListById()
    this.filter = Object.assign(this.filter, this.contractSearchCriteria)
  },
  data () {
    return {
      CONTRACT_STATUS,
      filter: {
        refCode: '',
        hotelId: '',
        agentId: '',
        agentIdList: [],
        contractValid: '',
        salePersonId: '',
        status: '',
        marketId: ''
      },
      sortedHotelList: [],
      sortedAgentList: [],
      sortedMarketList: [],
      sortedSalePersonList: [],
      marketListById: {}
    }
  },
  methods: {
    onSearchButtonClick: async function () {
      this.filter.agentIdList = []

      if (this.filter.marketId !== '') {
        const market = this.marketList.find((item) => {
          return item.id === this.filter.marketId
        })

        this.filter.agentIdList = [...market.agentIdList]
      }

      if (this.filter.contractValid === null) {
        this.filter.contractValid = ''
      }

      this.$store.dispatch(VUEX_EVENT.CONTRACT.SET_CONTRACT_SEARCH_CRITERIA, this.filter)
      this.$store.dispatch(VUEX_EVENT.CONTRACT.SET_CONTRACT_LIST_CURRENT_PAGE, 1)
      this.$emit('onSearchButtonClick', this.filter)
    },
    onResetButtonClick: async function () {
      this._resetFilter()

      this.$store.dispatch(VUEX_EVENT.CONTRACT.SET_CONTRACT_SEARCH_CRITERIA, this.filter)
      this.$store.dispatch(VUEX_EVENT.CONTRACT.SET_CONTRACT_LIST_CURRENT_PAGE, 1)
      this.$emit('onResetButtonClick', this.filter)
    },
    _resetFilter: function () {
      this.filter.refCode = ''
      this.filter.hotelId = ''
      this.filter.agentId = ''
      this.filter.agentIdList = []
      this.filter.contractValid = ''
      this.filter.salePersonId = ''
      this.filter.status = ''
      this.filter.marketId = ''
    },
    _prepareMarketListById: function () {
      const marketListById = {}
      for (let market of this.marketList) {
        const id = market.id
        marketListById[id] = market
      }

      return marketListById
    }
  }
}
</script>

<style scoped>
  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 177px;
  }
  .el-select {
    width: 100%;
  }
  .label-form-search {
    font-size: 13px;
    font-weight: 100;
  }
  #search-box{
    margin: 20px 0;
    padding: 15px 20px;
    background: #eeeeee;
    border: solid 1px #d8d6d6;
    border-radius: 5px;
  }
</style>
